// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rule__details__wrapper {
  display: flex;
  background: #eeeeee;
}

.rule__details__container {
  display: block;
  border-right: 1px solid black;
  margin: 1rem;
}

.rule__details__container:last-child {
  border: none;
}

.rule__details__title {
  font-size: var(--subheader);
  font-weight: 500;
  margin: 0;
}

.rule__details__box {
  display: flex;
  justify-content: space-between;
  padding: 0 1rem 0 0;
}

.rule__details__box__wrapper {
  padding: 0 1.5rem 0 0;
  width: max-content;
}

.rule__details__box__wrapper p {
  font-size: var(--caption);
}

.disabled {
  display: none;
}

.details__bold {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/Modules/RulesConfiguration/components/searchTab/RuleDetails/RuleDetails.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".rule__details__wrapper {\n  display: flex;\n  background: #eeeeee;\n}\n\n.rule__details__container {\n  display: block;\n  border-right: 1px solid black;\n  margin: 1rem;\n}\n\n.rule__details__container:last-child {\n  border: none;\n}\n\n.rule__details__title {\n  font-size: var(--subheader);\n  font-weight: 500;\n  margin: 0;\n}\n\n.rule__details__box {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 1rem 0 0;\n}\n\n.rule__details__box__wrapper {\n  padding: 0 1.5rem 0 0;\n  width: max-content;\n}\n\n.rule__details__box__wrapper p {\n  font-size: var(--caption);\n}\n\n.disabled {\n  display: none;\n}\n\n.details__bold {\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
